// PE-22 K3.4 — the "Nota" chip's write: SetRowDraft.notesPerCell[weekIdx].
// Split into its own file rather than added to programEditActions.ts, which
// was already at 494/500 lines (the 500-line cap) before this action — a
// pure extraction of one more `(draft, …) => Draft` action, same shape and
// same reuse of the exported `updateSlot`, no behaviour change to anything
// already in that file.
import { updateSlot } from "./programEditActions.js";
import type { Draft } from "./programEdit.js";

export const updateSetRowNote = (
  draft: Draft,
  sIdx: number,
  slotIdx: number,
  rowIdx: number,
  weekIdx: number,
  text: string,
): Draft => {
  const slot = draft.sessions[sIdx]?.slots[slotIdx];
  const row = slot?.setRows[rowIdx];
  if (!slot || !row) return draft;
  return updateSlot(draft, sIdx, slotIdx, {
    setRows: slot.setRows.map((r, i) =>
      i === rowIdx
        ? {
            ...r,
            notesPerCell: r.notesPerCell.map((n, w) =>
              w === weekIdx ? text : n,
            ),
          }
        : r,
    ),
  });
};
